import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import * as flyerDetailStore from "../../store/flyer-detail.store";
import { FlyerDetailView } from "../flyer-detail-view/flyer-detail-view.component";
import * as flyerStore from "../../../../store/flyer.store";
import * as userStore from "../../../../../../features/user/store/user.store";

export const FlyerDetail = () => {
  const { id } = useParams<{ id: string }>();
  const isLoading = useSelector(flyerDetailStore.isLoading);
  const formErrors = useSelector(flyerDetailStore.getFormErrors);
  const flyer = useSelector(flyerDetailStore.getFlyer);
  const permissions = useSelector(flyerStore.getPermissions);
  const user = useSelector(userStore.getUser);

  useEffect(() => {
    const userInitialized = () => Boolean(user.id);
    const shouldFetchFlyer = () => !flyer || flyer.id !== Number(id);

    if (userInitialized() && shouldFetchFlyer()) {
      flyerDetailStore.fetchFlyer(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, user, flyer]);

  return (
    <>
      <FlyerDetailView
        errors={useSelector(flyerDetailStore.getErrors)}
        flyer={flyer!}
        formErrors={formErrors}
        isLoaded={useSelector(flyerDetailStore.isLoaded)}
        isLoading={isLoading}
        isPageExportModalOpen={useSelector(flyerDetailStore.isPageExportModalOpen)}
        onAddPage={flyerDetailStore.addPage}
        onChangeName={flyerDetailStore.changeName}
        onClickPage={flyerDetailStore.goToPage}
        onDeletePage={flyerDetailStore.deletePage}
        onSave={flyerDetailStore.save}
        permissions={permissions!}
      />
    </>
  );
};
